import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { ConfigService } from './config.service';

/**
 * Single-use tickets for WebSocket handshakes.
 *
 * A browser cannot set headers on a WebSocket upgrade, so the bearer used to
 * ride in the URL (`?token=`), where proxies log it. Now the app asks the API
 * for a 30-second, one-redemption ticket (`POST /mux/ws-ticket`, bearer via
 * the usual interceptor) and connects with `?ticket=`. The ticket names the
 * user and nothing else. A null ticket means the API refused or is down; the
 * caller retries the way it would for an expired session.
 */
@Injectable({ providedIn: 'root' })
export class WsTicketService {
  constructor(private http: HttpClient) {}

  async ticket(): Promise<string | null> {
    try {
      const r = await firstValueFrom(this.http.post<{ ticket: string }>(`${ConfigService.muxUrl}/ws-ticket`, {}));
      return r?.ticket || null;
    } catch {
      return null;
    }
  }

  /** Append the ticket to a ws:// or wss:// URL, whichever separator fits. */
  static withTicket(url: string, ticket: string | null): string {
    if (!ticket) return url;
    return `${url}${url.includes('?') ? '&' : '?'}ticket=${encodeURIComponent(ticket)}`;
  }
}
